"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    return Array.from(Array(n).keys());
};